export const DELETE_FS_UPLOAD_LOADING = "delete/fs/upload/loading"
export const DELETE_FS_UPLOAD_ERROR = "delete/fs/upload/error"
export const DELETE_FS_UPLOAD_SUCCESS = "delete/fs/upload/success"

export const DELETE_FS_VIDEO_LOADING = "delete/fs/video/loading"
export const DELETE_FS_VIDEO_ERROR = "delete/fs/video/error"
export const DELETE_FS_VIDEO_SUCCESS = "delete/fs/video/success"

